import { TranslateResult } from "vue-i18n";

export class VerificationError {
  otpToken: TranslateResult = "";
}
